import api from "./api";

var _reported = {};

export function reportFrontendError(error, componentOrPage, extraInfo) {
  if (!error) return;

  var key = (error.message || "") + "|" + (componentOrPage || "");
  if (_reported[key]) return;
  _reported[key] = true;
  setTimeout(function() { delete _reported[key]; }, 300000); // 5 min dedup local

  var user = null;
  try {
    var raw = localStorage.getItem("user_cache");
    if (raw) user = JSON.parse(raw);
  } catch(e) { console.warn("vigia: failed to read user cache", e); }

  var payload = {
    error_type: error.name || "FrontendError",
    message: (error.message || String(error)).substring(0, 1000),
    stack: (error.stack || "").substring(0, 3000),
    url: window.location.pathname,
    page: window.location.pathname,
    component: componentOrPage || "",
    user_agent: navigator.userAgent,
    user_id: user ? user.id : null,
    user_name: user ? user.name : null,
  };

  if (extraInfo) {
    payload.component = extraInfo.component || payload.component;
    payload.page = extraInfo.page || payload.page;
  }

  api.post("/vigia/client-error", payload).catch(function(err) { console.warn("vigia: report failed", err.message); });
}

// Global error handler
if (typeof window !== "undefined") {
  window.addEventListener("error", function(event) {
    reportFrontendError(event.error || new Error(event.message), "window.onerror");
  });

  window.addEventListener("unhandledrejection", function(event) {
    var err = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    reportFrontendError(err, "unhandledrejection");
  });
}
